import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RelatedArticles = ({ articles }) => {
  const navigate = useNavigate();

  if (!articles?.length) return null;

  const handleArticleClick = (article) => {
    navigate(`/article-detail-page?slug=${article.slug}`);
  };

  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-8 my-12">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="BookOpen" size={20} className="text-primary" />
        <h3 className="font-heading font-bold text-xl text-accent-800">
          Related Articles
        </h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {articles.map((article) => (
          <article
            key={article.id}
            onClick={() => handleArticleClick(article)}
            className="group cursor-pointer"
          >
            <div className="relative overflow-hidden rounded-xl mb-3">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
            
            <h4 className="font-heading font-semibold text-accent-800 mb-2 group-hover:text-primary transition-colors line-clamp-2">
              {article.title}
            </h4>
            
            <div className="flex items-center space-x-1 text-xs text-accent-500">
              <Icon name="Clock" size={12} />
              <span>{article.readTime} min read</span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default RelatedArticles;